import React from 'react';
import styles from './banner.module.css';
import logo from '../../assets/mtc logo.png';

const Banner: React.FC<any> = ()=>{

    return(
        <div className={styles.nav}>

            <div className={styles.container}>

                {/** Logo section */}
                <div className={styles.logo}>
                    <img src={logo} alt="MTC logo" />
                </div>

                {/** Title */}
                <div className={styles.title}>
                    <h1>MULTIPLICATION TABLES CHALLENGE</h1>
                </div>
                
            </div>
            
        </div>
    )
}


export default Banner;